var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1411_5902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1411_5902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66154 3.29815H11.1379C11.1379 3.46227 11.134 3.61238 11.1379 3.76248C11.1478 4.01667 11.294 4.17878 11.5113 4.18279C11.7366 4.18679 11.8907 4.01467 11.8986 3.74847C11.9025 3.60637 11.8986 3.46427 11.8986 3.30416C11.9756 3.29615 12.0388 3.28214 12.102 3.28214C12.8429 3.28214 13.5857 3.28014 14.3266 3.28214C14.6644 3.28214 14.7968 3.41624 14.7988 3.75648C14.8007 4.23682 14.7988 4.71917 14.7988 5.19952C14.7988 5.22353 14.7889 5.24755 14.781 5.28758H2.00666C2.00666 4.72317 1.99283 4.16878 2.01259 3.61438C2.02049 3.40823 2.17459 3.28614 2.38993 3.28414C3.21376 3.28214 4.03759 3.28414 4.90093 3.28414C4.90093 3.45226 4.89698 3.60837 4.90093 3.76449C4.90884 4.01266 5.06293 4.18078 5.27828 4.18279C5.49559 4.18479 5.64969 4.02267 5.65957 3.77249C5.6655 3.62238 5.65957 3.47228 5.65957 3.29815H5.66154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65787 2.88132H4.90121C4.90121 2.69719 4.88936 2.52106 4.90319 2.34694C4.91899 2.13479 5.0889 1.98868 5.29238 2.00069C5.50377 2.0127 5.63812 2.12678 5.6559 2.34293C5.66973 2.51706 5.65787 2.69118 5.65787 2.87932V2.88132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 2.8751C11.1429 2.68696 11.1311 2.51084 11.1469 2.33871C11.1666 2.12256 11.3049 2.01048 11.5144 2.00047C11.7159 1.99046 11.8818 2.14057 11.8976 2.35272C11.9095 2.51884 11.8996 2.68696 11.8996 2.8751H11.1429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6H14.8V13C14.8 13.5523 14.3523 14 13.8 14H3C2.44772 14 2 13.5523 2 13V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40321 7.19922C9.7278 7.19971 10.801 8.27668 10.8 9.60464C10.799 10.9282 9.71991 12.0012 8.39236 11.9992C7.06974 11.9977 5.99803 10.9173 6 9.58886C6.00197 8.27076 7.08009 7.19873 8.40321 7.19922ZM7.12988 9.20374C7.1215 9.21015 7.11065 9.21607 7.10178 9.22445C6.98445 9.34132 6.86811 9.45917 6.75029 9.57506C6.7079 9.61697 6.73994 9.63965 6.76656 9.66628C7.15058 10.0504 7.53559 10.4346 7.91862 10.8197C7.95461 10.8557 7.97679 10.8616 8.01623 10.8221C8.68863 10.1476 9.36202 9.47397 10.0369 8.80136C10.0783 8.76043 10.0773 8.73478 10.0359 8.69583C9.93435 8.59868 9.83231 8.50154 9.73815 8.39749C9.68245 8.33585 9.6509 8.33733 9.59174 8.397C9.07314 8.92069 8.55011 9.43994 8.03102 9.96314C7.98221 10.0124 7.95609 10.0154 7.9063 9.96412C7.67263 9.72496 7.43502 9.49024 7.1984 9.25404C7.17917 9.2348 7.1634 9.20916 7.12988 9.20374Z",
    fill: "#62BA60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveIcon);
export default __webpack_public_path__ + "static/media/reserve-icon.50a3beac5d36d6722a1a1eb3b0d05d86.svg";
export { ForwardRef as ReactComponent };